export default "__VITE_ASSET__BZz4o0M1__"